module.exports = __webpack_public_path__ + "static/img/1047_big.6ff2059.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1047_big.png
// module id = pbNY
// module chunks = 1